module.exports = __webpack_public_path__ + "static/media/alternate_logo.8fce00bf.svg";